// extracted by mini-css-extract-plugin
export default {"tab":"PatientNavTab_tab__Hsbc1","title":"PatientNavTab_title__LUMVP","underline":"PatientNavTab_underline__mBWG3"};